import { motion } from "framer-motion";
import BulbIcon from "../../../app/assets/images/storyMagic/bulbIcon.png";
import RainbowBG from "../../../app/assets/images/storyMagic/raindow-fade.png";
import BirdIcon from "../../../app/assets/images/storyMagic/bird3.svg";
import Page1 from "../../../app/assets/images/storyMagic/page1.png";
import Page2 from "../../../app/assets/images/storyMagic/page2.png";
import Page3 from "../../../app/assets/images/storyMagic/page3.png";
import Page4 from "../../../app/assets/images/storyMagic/page4.png";

// Animation variants
const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const scaleIn = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: {
    opacity: 1,
    scale: 1,
    transition: { duration: 0.6, ease: "easeOut" }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2,
      delayChildren: 0.1
    }
  }
};

const fadeIn = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { duration: 0.8, ease: "easeOut" }
  }
};

const SolutionsSection = () => {
  return (
    <motion.div
      className="flex justify-center items-center flex-col py-6 sm:py-11 sm:pt-[60px] relative z-0"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: false, amount: 0.3 }}
    >
      <motion.h3
        className="flex items-center gap-2 text-3xl sm:text-[50px] font-bold uppercase"
        variants={fadeInUp}
      >
        <img src={BulbIcon} alt="icon" />
        Solutions
      </motion.h3>
      <motion.div
        className="flex flex-col gap-6 sm:gap-11 text-center w-full relative mt-8 px-5"
        variants={staggerContainer}
      >
        <motion.div
          className="flex flex-col gap-2 items-center"
          variants={fadeInUp}
        >
          <h3 className="text-xl sm:text-[30px] font-semibold relative pb-1.5">
            Creative Storytelling Tools:
            <div className="bg-[#7F51D5] w-[85%] h-[3px] absolute mx-auto left-0 right-0 bottom-0"></div>
          </h3>
          <p className="text-[#D1D1D1] text-lg sm:text-xl items-center">
            Interactive features that help writers visualize, organize, and
            publish their stories effortlessly.
          </p>
        </motion.div>
        <motion.div
          className="flex flex-col gap-2 items-center"
          variants={fadeInUp}
        >
          <h3 className="text-xl sm:text-[30px] font-semibold relative pb-1.5">
            Collaboration Hub:
            <div className="bg-[#7F51D5] w-[85%] h-[3px] absolute mx-auto left-0 right-0 bottom-0"></div>
          </h3>
          <p className="text-[#D1D1D1] text-lg sm:text-xl items-center">
            A space for creators, designers, and editors to work together in
            real time.
          </p>
        </motion.div>
        <motion.div
          className="flex flex-col gap-2 items-center"
          variants={fadeInUp}
        >
          <h3 className="text-xl sm:text-[30px] font-semibold relative pb-1.5">
            Story Showcase:
            <div className="bg-[#7F51D5] w-[85%] h-[3px] absolute mx-auto left-0 right-0 bottom-0"></div>
          </h3>
          <p className="text-[#D1D1D1] text-lg sm:text-xl items-center">
            A digital gallery where stories, films, and ideas get the spotlight
            they deserve.
          </p>
        </motion.div>
        <motion.div
          className="flex flex-col gap-2 items-center"
          variants={fadeInUp}
        >
          <h3 className="text-xl sm:text-[30px] font-semibold relative pb-1.5">
            AI-Powered Assistance:
            <div className="bg-[#7F51D5] w-[85%] h-[3px] absolute mx-auto left-0 right-0 bottom-0"></div>
          </h3>
          <p className="text-[#D1D1D1] text-lg sm:text-xl items-center">
            Smart tools to enhance writing, refine tone, and spark new ideas.
          </p>
        </motion.div>

        <motion.img
          className="absolute right-0 -bottom-36 z-[-1]"
          src={RainbowBG}
          alt=""
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{
            opacity: 1,
            scale: 1,
          }}
          viewport={{ once: false }}
          animate={{
            opacity: [0.7, 1, 0.7],
            scale: [1, 1.05, 1],
          }}
          transition={{
            opacity: {
              delay: 1,
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut",
            },
            scale: {
              delay: 1,
              duration: 3,
              repeat: Infinity,
              ease: "easeInOut",
            },
            default: { duration: 1, ease: "easeOut" },
          }}
        />
      </motion.div>

      <motion.div
        className="grid grid-cols-2 sm:grid-cols-4 gap-5 sm:gap-7 pt-7 sm:pt-14 px-6"
        variants={staggerContainer}
      >
        <motion.img src={Page1} alt="" variants={scaleIn} />
        <motion.img src={Page2} alt="" className="pt-8 sm:pt-20" variants={scaleIn} />
        <motion.img src={Page3} alt="" variants={scaleIn} />
        <motion.img src={Page4} alt="" className="pt-8 sm:pt-20" variants={scaleIn} />
      </motion.div>

      <motion.div
        className="absolute top-[-14px] z-[-1]"
        variants={fadeIn}
      >
        <h2
          className="text-[#a371ff18] font-outline-2 text-4xl sm:text-6xl lg:text-[100px] xl:text-[130px] font-bold uppercase leading-none text-right relative"
          id="mind"
        >
          Generate story
          <motion.img
            className="absolute w-[13%] sm:w-[16%] -right-[3%] sm:-right-[6%] -top-[56%]"
            src={BirdIcon}
            alt=""
            initial={{ opacity: 0, y: -30, x: 20, rotate: -15 }}
            whileInView={{
              opacity: 1,
              y: 0,
              x: 0,
              rotate: 0,
            }}
            viewport={{ once: false }}
            animate={{
              y: [0, -25, 0],
              x: [0, -15, 0],
              rotate: [0, -15, 15, 0],
            }}
            transition={{
              opacity: { delay: 0.3, duration: 0.8, ease: "easeOut" },
              x: { delay: 0.3, duration: 0.8, ease: "easeOut" },
              y: {
                delay: 1.1,
                duration: 3.5,
                repeat: Infinity,
                ease: "easeInOut",
              },
              rotate: {
                delay: 1.1,
                duration: 3.5,
                repeat: Infinity,
                ease: "easeInOut",
              },
            }}
          />
        </h2>
      </motion.div>
    </motion.div>
  );
};

export default SolutionsSection;
